import { render, staticRenderFns } from "./survey-type.vue?vue&type=template&id=226423a3"
import script from "./survey-type.component.ts?vue&type=script&lang=ts&external"
export * from "./survey-type.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports